import { Box, StackView, Typography } from "@telus-uds/components-base";
import { useAuthContext } from "src/context/authContext";
import IconLeaf from "../images/icons/IconLeaf";
import { SUPPORT_FOOTER_EN, SUPPORT_FOOTER_FR } from "src/Utilities/constants";

function LockUp() {
  const { userLanguage } = useAuthContext();
  return (
    <Box space={2} variant={{ background: "lightest" }}>

      <StackView
        direction="row"
        tokens={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {userLanguage == "en" ? (
          <Typography htmlFor="telusFooter" className="h-7 mt-[6px]">
            <Typography tag="strong" variant={{ bold: true }}>
              {" "}
              
              <font color='blue'><a href='https://publicmobile.ca/en/get-help/articles/eversafe-troubleshooting'><u>Need help?</u></a></font>
            </Typography>
          </Typography>
        ) : (
          <Typography htmlFor="telusFooter" className="h-7 mt-[6px]">
            <Typography tag="strong" variant={{ bold: true }}>
              {" "}
              <font color='blue'><a href='https://publicmobile.ca/fr/get-help/articles/eversafe-troubleshooting'><u>Besoin d’aide?</u></a></font>
            </Typography>
          </Typography>
        )}
      </StackView>

      <StackView
        direction="row"
        tokens={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <IconLeaf h={35} w={22} />
        {userLanguage == "en" ? (
          <Typography htmlFor="telusFooter" className="h-7 mt-[6px]">
            Secured by
            <Typography tag="strong" variant={{ bold: true }}>
              {" "}
              EverSafe&trade;
            </Typography>
          </Typography>
        ) : (
          <Typography htmlFor="telusFooter" className="h-7 mt-[6px]">
            Protégé par&nbsp;
            <Typography tag="strong" variant={{ bold: true }}>
              AccèsSûr<sup>MC</sup>
            </Typography>
          </Typography>
        )}
      </StackView>
    </Box>
  );
}

export default LockUp;
